module.exports = __webpack_public_path__ + "desktop_76x76.7eaf341e32d9529eb0f33f803ace9227.png";